import Countfot from "../Countdown/Countfot";

export const PRODUCTS = [
  { name: "This Conference brings together delegates" },
  { name: "comprising officials from national and county" },
  { name: "governments, representatives of national" },
  { name: "authorities from the regional blocs, regional think"},
  { name: "tanks, as well as development partners, civil society"},
  { name: "and special interest groups."},
];

const productsText = PRODUCTS.map((item) => item.name).join(" ");

// "This Conference brings together delegates comprising officials from national and county governments, representatives of national authorities from the regional blocs, regional think tanks, as well as development partners, civil society and special interest groups."

const targetDatefooter = '2023-06-21T00:00:00';

export const RESOURCES = [
  { name: "Pwani University", link: "https://www.pu.ac.ke/"},
  { name: "Kilifi County Government", link: "https://kilifi.go.ke/22-27/" },
  { name: "State Department for ASAL", link: "devolutionasals.go.ke" },
];
export const COMPANY = [

  { name: "THEMATIC AREAS", link: "#" },
  { name: "YOUTH EVENT", link: "/youth_event" },
  { name: "OUR SPEAKERS", link: "#" },
  { name: "REGISTER", link: "/profile" },
];
export const SUPPORT = [
  { name: " +254 724 256078 ", link: "#" },
  { name: "+254 735 710029", link: "#" },
  { name: "" },
  { name: "" },
  { name: "conference@kippra.or.ke. ", link: "mailto:conference@kippra.or.ke" },
  { name: <span className="text-sm"><Countfot targetDate={targetDatefooter} /></span> },
];


export const Icons = [
  { name: "logo-linkedin", link: "https://www.linkedin.com/company/kippra/mycompany/", src: "https://p7.hiclipart.com/preview/297/542/427/5bbf4bcd44bbe-thumbnail.jpg", },
  { name: "logo-twitter", link: "https://twitter.com/KIPPRAKENYA", src: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Twitter-new-logo.jpg/600px-Twitter-new-logo.jpg?20230725024809", },
  { name: "logo-instagram", link: "https://www.instagram.com/kipprakenya/", src: "https://p7.hiclipart.com/preview/477/609/118/logo-computer-icons-clip-art-instagram-logo-thumbnail.jpg", },
  { name: "logo-facebook", link: "https://www.facebook.com/KIPPRAKENYA", src: "https://p7.hiclipart.com/preview/282/704/972/facebook-messenger-logo-icon-facebook-picture-thumbnail.jpg",},
  { name: "logo-youtube", link: "https://www.youtube.com/channel/UCLmEy7_V5ZLMjsw0PR0Csig", src: "https://p7.hiclipart.com/preview/217/591/618/youtube-computer-icons-clip-art-youtube-logo-thumbnail.jpg", },
];
